import React from 'react';
import '../homePage/homePage.scss'
import './aboutMe.scss'

const Contact = () => {
    return (
        <>
        <section className="about-img-mobile">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="about-img">
                            <img src="/images/profilephoto.png" alt="Image" />
                        </div>
                    </div>
                </div>
            </div>
        </section >
</>
    )
}
export default Contact